import HeroCard from "@/components/heroCard";
import { HERO_CONSTANTS } from "./constants";

const HeroComponent = () => {
  return <HeroCard backgroundImage="/background/banner-bg2.png" {...HERO_CONSTANTS} />;
};

export default HeroComponent;
